import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from '../index.css';

export interface IErrorProps {
  error: string | null;
}

export const Error = ({ error }: IErrorProps) => <div {...mergeStyles(styles['error'])}>{error}</div>;
